import { render, staticRenderFns } from "./createComment.vue?vue&type=template&id=1d8f7f7c&"
import script from "./createComment.vue?vue&type=script&lang=js&"
export * from "./createComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports